/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Email_HintInputs */



/**
* | output |
* | --- |
* | "Optional. We'll email them an invite to log in." |
*
* @param {User_Email_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_email_hint = /** @type {((inputs?: User_Email_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Email_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Optionnel. Nous lui enverrons une invitation par e-mail pour se connecter.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opcional. Le enviaremos una invitación por correo para iniciar sesión.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Opcional. Enviaremos um convite por e-mail para a pessoa entrar.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Facoltativo. Gli invieremo un invito via email per accedere.")
	return /** @type {LocalizedString} */ ("Optional. We'll email them an invite to log in.")
});